module.exports = __webpack_public_path__ + "img/default.0b271b20.jpg";